// owned uniform pager spec; independent of the SwiftUI catalog.
import type { HostComponent, ViewProps } from 'react-native';
import type { DirectEventHandler, Int32, Double, WithDefault } from 'react-native/Libraries/Types/CodegenTypes';
import codegenNativeComponent from 'react-native/Libraries/Utilities/codegenNativeComponent';
import codegenNativeCommands from 'react-native/Libraries/Utilities/codegenNativeCommands';
import type * as React from 'react';
interface NativeProps extends ViewProps {
  initialPage?: WithDefault<Int32, 0>;
  scrollEnabled?: WithDefault<boolean, true>;
  orientation?: WithDefault<'horizontal' | 'vertical', 'horizontal'>;
  layoutDirection?: WithDefault<'ltr' | 'rtl', 'ltr'>;
  offscreenPageLimit?: WithDefault<Int32, -1>;
  pageMargin?: WithDefault<Double, 0>;
  overdrag?: WithDefault<boolean, false>;
  overScrollMode?: WithDefault<'auto' | 'always' | 'never', 'auto'>;
  keyboardDismissMode?: WithDefault<'none' | 'on-drag', 'none'>;
  onPageScroll?: DirectEventHandler<Readonly<{
    position: Int32;
    offset: Double;
  }>>;
  onPageSelected?: DirectEventHandler<Readonly<{
    position: Int32;
  }>>;
  onPageScrollStateChanged?: DirectEventHandler<Readonly<{
    pageScrollState: string;
  }>>;
}
interface NativeCommands {
  setPage(viewRef: React.ElementRef<HostComponent<NativeProps>>, index: Int32): void;
  setPageWithoutAnimation(viewRef: React.ElementRef<HostComponent<NativeProps>>, index: Int32): void;
  setScrollEnabledImperatively(viewRef: React.ElementRef<HostComponent<NativeProps>>, enabled: boolean): void;
}
const NativeComponentRegistry = require('react-native/Libraries/NativeComponent/NativeComponentRegistry');
const {
  ConditionallyIgnoredEventHandlers
} = require('react-native/Libraries/NativeComponent/ViewConfigIgnore');
const {
  dispatchCommand
} = require("react-native/Libraries/ReactNative/RendererProxy");
let nativeComponentName = 'OneNativePager';
export const __INTERNAL_VIEW_CONFIG = {
  uiViewClassName: "OneNativePager",
  directEventTypes: {
    topPageScroll: {
      registrationName: "onPageScroll"
    },
    topPageSelected: {
      registrationName: "onPageSelected"
    },
    topPageScrollStateChanged: {
      registrationName: "onPageScrollStateChanged"
    }
  },
  validAttributes: {
    initialPage: true,
    scrollEnabled: true,
    orientation: true,
    layoutDirection: true,
    offscreenPageLimit: true,
    pageMargin: true,
    overdrag: true,
    overScrollMode: true,
    keyboardDismissMode: true,
    ...ConditionallyIgnoredEventHandlers({
      onPageScroll: true,
      onPageSelected: true,
      onPageScrollStateChanged: true
    })
  }
};
export default NativeComponentRegistry.get(nativeComponentName, () => __INTERNAL_VIEW_CONFIG);
export const Commands = {
  setPage(ref, index) {
    dispatchCommand(ref, "setPage", [index]);
  },
  setPageWithoutAnimation(ref, index) {
    dispatchCommand(ref, "setPageWithoutAnimation", [index]);
  },
  setScrollEnabledImperatively(ref, enabled) {
    dispatchCommand(ref, "setScrollEnabledImperatively", [enabled]);
  }
};